// machineActions.js
export const INIT_MACHINE_LIST_REQUEST_DASHBOARD = 'INIT_MACHINE_LIST_REQUEST_DASHBOARD';
export const SET_MACHINE_LIST_DASHBOARD = 'SET_MACHINE_LIST_DASHBOARD';
export const ERROR_MACHINE_LIST_DASHBOARD = 'ERROR_MACHINE_LIST_DASHBOARD';
export const SET_MACHINE_DASHBOARD = 'SET_MACHINE_DASHBOARD';
export const ERROR_MACHINE_DASHBOARD = 'ERROR_MACHINE_DASHBOARD';

// chartActions.js
export const INIT_CHART_REQUEST_DASHBOARD = 'INIT_CHART_REQUEST_DASHBOARD';
export const SET_CHART_DATA_DASHBOARD = 'SET_CHART_DATA_DASHBOARD';
export const ERROR_CHART_DATA_DASHBOARD = 'ERROR_CHART_DATA_DASHBOARD';

// machineActions.js
export function initMachineListRequestDashBoard() {
    return { type: INIT_MACHINE_LIST_REQUEST_DASHBOARD };
}

export function setMachineListDashBoard(data) {
    return { type: SET_MACHINE_LIST_DASHBOARD, payload: data };
}

export function errorMachineListDashBoard(error) {
    return { type: ERROR_MACHINE_LIST_DASHBOARD, payload: error };
}

export function setMachineDashBoard(data) {
    return { type: SET_MACHINE_DASHBOARD, payload: data };
}

export function errorMachineDashBoard(data) {
    return { type: ERROR_MACHINE_DASHBOARD, payload: data };
}

// chartActions.js
export function initChartRequestDashBoard() {
    return { type: INIT_CHART_REQUEST_DASHBOARD };
}

export function setChartDataDashBoard(data) {
    return { type: SET_CHART_DATA_DASHBOARD, payload: data };
}

export function errorChartDataDashBoard(error) {
    return { type: ERROR_CHART_DATA_DASHBOARD, payload: error };
}
